import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { toast } from 'react-toastify';

const root = ReactDOM.createRoot(document.getElementById('root'));
const queryClient = new QueryClient(
  {
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: false,
        onError: error => {
          console.error('Query error:', error);
          toast.error(
            error?.data?.message ||
            error?.data?.error ||
            error?.message ||
            `Request failed${error?.status ? ` (${error.status})` : ''}`
          );
        }
      },
    }
  },
);

root.render(
  //<React.StrictMode>
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </Provider>
  //</React.StrictMode>
);
